<template>
    <div class="wggl">
        <img src="../../assets/images/wggl.png" alt="">
    </div>
</template>

<script>
    export default {
        name: "NetworkOverview"
    }
</script>

<style scoped>

</style>
